import { api } from 'services';
import { omitBy } from 'lodash';
import { isNil } from 'lodash';

export default {
  getRentOrderList(params = {}) {
    const { limit, cursor, q, status, inspect_end_date, inspect_start_date } =
      params;
    return api.get('/inspections/rent_order', {
      params: omitBy(
        {
          limit,
          cursor,
          q,
          'statuses[]': status,
          inspect_end_date,
          inspect_start_date,
        },
        isNil
      ),
    });
  },
  getRentOrderDetails(orderId) {
    return api.get(`/inspections/orders/${orderId}`);
  },
  getDamagePenaltyList({ product_id } = {}) {
    return api.get('/inspections/penalties', {
      params: omitBy({ product_id }, isNil),
    });
  },
  startInspection(orderId, payload) {
    return api.post(`inspections/orders/${orderId}/start`, payload);
  },
  finishInspection(orderId, payload) {
    return api.post(`inspections/orders/${orderId}/finish`, payload);
  },
  getPenaltyDetails(id) {
    return api.get(`/inspections/penalties/${id}`);
  },
  createPenalty(payload) {
    return api.post('/inspections/penalties', payload);
  },
  updatePenalty(id, payload) {
    return api.put(`/inspections/penalties/${id}`, payload);
  },
  deletePenalty(id) {
    return api.delete(`/inspections/penalties/${id}/delete`);
  },
  getRentOrderInspectionDetails(id) {
    return api.get(`/inspections/orders/${id}/detail`);
  },
  updateInspectionSerialNumber(id, payload) {
    return api.put(`/inspections/${id}`, payload);
  },
};
